import React, { FC } from 'react'

import { HeadingSmall, BodyText, Label } from '@pb/components'
import { getLabelFromStorage } from '@pb/utils'

import styles from './RewardHeading.scss'

interface RewardHeadingProps {
  totalRewardItems: number
}

const RewardHeading: FC<RewardHeadingProps> = ({ totalRewardItems }) => (
  <HeadingSmall Tag="h1" className={styles.heading}>
    <Label copyKey="profile.account.my.benefits" />
    <BodyText Tag="span">
      {getLabelFromStorage('account.digitalreceipts.items').replace('{0}', `${totalRewardItems}`)}
    </BodyText>
  </HeadingSmall>
)

export default RewardHeading
